import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, GsRole } from '@gs/auth';
import App from './App';
import './index.css';

const ROLE_MAPPINGS = [
  { groupId: '7a9bf9f7-dde9-44ff-86c1-deee829462c4', role: GsRole.ADMIN },
  { groupId: 'e1594515-5d26-4b84-b14c-30f69d7d3ae6', role: GsRole.GESTIONNAIRE },
  { groupId: '8dd154cd-c43e-4fd8-aa4f-50f385d94486', role: GsRole.UTILISATEUR },
];

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 1000 * 60 * 2, retry: 1 },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider
        roleMappings={ROLE_MAPPINGS}
        defaultRole={GsRole.UTILISATEUR}
        appKey="admin"
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
